// frontend/src/pages/model/ModelSelect.jsx
// A native select in the graphite style, for the Model page's table: a table of
// up to 200 fields has three of these per row, and a native select is light,
// keyboard-complete and right on touch screens. `choices` are { value, label }.
import React from 'react';
import { ChevronDown } from 'lucide-react';

export default function ModelSelect({ label, value, choices, onChange, disabled = false }) {
  return (
    <span className="relative inline-flex w-full items-center">
      <select
        aria-label={label} value={value} disabled={disabled} onChange={(e) => onChange(e.target.value)}
        className="h-8 w-full appearance-none rounded-lg bg-[var(--ui-inset)] pl-2.5 pr-7 text-[12.5px] text-[var(--ui-text)] [color-scheme:dark] hover:bg-[var(--ui-inset-hover)] focus:outline-none focus-visible:ring-2 focus-visible:ring-white/30 disabled:cursor-not-allowed disabled:opacity-60"
      >
        {choices.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
      </select>
      <ChevronDown className="pointer-events-none absolute right-2 h-3 w-3 text-[var(--ui-text-muted)]" aria-hidden="true" />
    </span>
  );
}
